import { API_URL, makeAuthenticatedRequest } from '@/utils/apiUtils';

export const filterService = {
  async getCompanyFilters() {
    let url = `${API_URL}/filter/fundfamily/`;

    return await makeAuthenticatedRequest(url, 'GET');
  },
};